import axiosClient from '../../api/axiosClient.js';
import { fetchPageData } from '../../api/utils.js';

export async function getTournaments() {
  return fetchPageData(`/api/tournaments/tournaments/`);
}

export const tournamentsQuery = () => {
  return {
    queryKey: ['tournaments'],
    queryFn: async () => getTournaments(),
    refetchOnWindowFocus: false
  };
};

export async function getTournamentsRounds({tournamentId}) {
  return fetchPageData(`/api/tournaments/rounds/?tournament_id=${tournamentId}`);
}

export const tournamentsRoundsQuery = ({tournamentId}) => {
  return {
    queryKey: ['tournamentsRounds', tournamentId],
    queryFn: async () => getTournamentsRounds({tournamentId}),
    refetchOnWindowFocus: false,
    enabled: !!tournamentId
  };
};

export async function getTournamentsMatchups({tournamentId}) {
  return fetchPageData(`/api/tournaments/matchups/?tournament_id=${tournamentId}`);
}

export const tournamentsMatchupsQuery = ({tournamentId}) => {
  return {
    queryKey: ['tournamentsMatchups', tournamentId],
    queryFn: async () => getTournamentsMatchups({tournamentId}),
    refetchOnWindowFocus: false,
    enabled: !!tournamentId
  };
};

export async function getTournamentsTeams({tournamentId, roundId}) {
  return fetchPageData(`/api/tournaments/teams/?tournament_id=${tournamentId}${roundId ? `&round_id=${roundId}` : ''}`);
}

export const tournamentsTeamsQuery = ({tournamentId, roundId}) => {
  return {
    queryKey: ['tournamentsTeams', tournamentId, roundId],
    queryFn: async () => getTournamentsTeams({tournamentId, roundId}),
    refetchOnWindowFocus: false,
    enabled: !!tournamentId
  };
};

export async function getTournamentsTeamScores({tournamentId, roundNumber}) {
  return fetchPageData(`/api/tournaments/teamscores/?tournament_id=${tournamentId}${roundNumber ? `&round_number=${roundNumber}` : ''}`);
}

export const tournamentsTeamScoresQuery = ({tournamentId, roundNumber}) => {
  return {
    queryKey: ['tournamentsTeamScores', tournamentId, roundNumber],
    queryFn: async () => getTournamentsTeamScores({tournamentId, roundNumber}),
    refetchOnWindowFocus: false,
    enabled: !!tournamentId
  };
};

export async function getTournamentsUserScores({tournamentId, roundNumber}) {
  return fetchPageData(`/api/tournaments/userscores/?tournament_id=${tournamentId}${roundNumber ? `&round_number=${roundNumber}` : ''}`);
}

export const tournamentsUserScoresQuery = ({tournamentId, roundNumber}) => {
  return {
    queryKey: ['tournamentsUserScores', tournamentId, roundNumber],
    queryFn: async () => getTournamentsUserScores({tournamentId, roundNumber}),
    refetchOnWindowFocus: false,
    enabled: !!tournamentId
  };
};

async function getGame({id}) {
  const response = await axiosClient.get(`/api/games/games/${id}`);
  return response.data;
}

export const gameQuery = ({id}) => {
  return {
    queryKey: ['game', id],
    queryFn: async () => getGame({id}),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    enabled: !!id
  };
};

async function getSessions({gameId}) {
  return fetchPageData(`/api/games/sessions/${gameId ? `?game=${gameId}` : ''}`);
}

export const sessionsQuery = ({gameId}) => {
  return {
    queryKey: ['sessions', gameId],
    queryFn: async () => getSessions({gameId}),
    refetchOnWindowFocus: false
  };
};

export async function createGameSession({game, user}) {
  const body = { game, user, level1: 'not_started', is_ready: true };
  try {
    const { data } = await axiosClient.post(`/api/games/sessions/`, body);
    return data;
  } catch (err) {
    // BE partial unique index on (user, game) WHERE completed=false can surface as IntegrityError (500) on an inter-request race; one retry picks up the just-created row via the serializer's reuse path.
    if (err?.response?.status === 500) {
      const { data } = await axiosClient.post(`/api/games/sessions/`, body);
      return data;
    }
    throw err;
  }
}